import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import classNames from 'classnames';

import ElementHeightObserver from 'components/ElementHeightObserver';
import { ElementNames } from 'constants/app';
import useContextualHelp from 'hooks/useContextualHelp';
import { getContextualHelp } from 'redux/modules/tooltip/selectors';

import ToggleSwitch from './components/ToggleSwitch';

import styles from './styles.module.scss';

const ContextualHelpSection = () => {
  const contextualHelpValue = useSelector(getContextualHelp);
  const { handleToggleSwitch } = useContextualHelp();
  const { t } = useTranslation();

  return (
    <ElementHeightObserver
      elementName={ElementNames.CONTEXTUAL_HELP}
      className={classNames('biab_navigation-section', 'biab_tooltips-nav', styles.contextualHelp)}
    >
      {t('navigation.contextualHelp')}
      <ToggleSwitch checked={contextualHelpValue} onChange={handleToggleSwitch} />
    </ElementHeightObserver>
  );
};

export default ContextualHelpSection;
